import { Injectable } from '@angular/core';
import * as localForage from 'localforage';
import * as UserActions from '@app/core/user/store/actions/user.actions';
import { IAppState } from '@app/store';
import { EmptyResponse, UsersService, UserWishes, WishlistAddRequest } from '@vestiaire/api-sdk-angular';
import { Store } from '@ngrx/store';
import { from as fromPromise, Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

@Injectable()
export class WishlistService {
  wishesItems = [];

  constructor(private store: Store<IAppState>, private usersService: UsersService) {}

  setWishesItems() {
    fromPromise(localForage.getItem('wishesItems')).subscribe(
      res => {
        if (!res) {
          this.usersService.getWishesProduct().subscribe(
            wishesItems => {
              const newWishesItems = Object.assign(this.wishesItems, wishesItems.data);
              localForage.setItem('wishesItems', newWishesItems);
              this.store.dispatch({
                type: UserActions.SET_USER_WISHED_ITEMS,
                payload: newWishesItems
              });
            },
            error => {
              console.log(error);
            }
          );
        } else {
          this.store.dispatch({
            type: UserActions.SET_USER_WISHED_ITEMS,
            payload: res
          });
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  wishItem(id: string): Observable<EmptyResponse> {
    this.addWishedItemToLocalForage(id);
    const data: WishlistAddRequest = {
      idProduct: id
    };
    return this.usersService.addProductToWishlist(data);
  }

  unwishAnItem(id: string): Observable<HttpResponse<UserWishes>> {
    // return false; // il faut créer la bonne route pour que cela fonctionne
    this.removeWishedItemToLocalForage(id);
    return this.usersService.removeProductFromWishlist(id);
  }

  addWishedItemToLocalForage(idItem: string) {
    fromPromise(localForage.getItem('wishesItems')).subscribe(
      res => {
        const newWishesItems = Object.keys(res).map(index => {
          return res[index];
        });
        if (newWishesItems.indexOf(idItem) === -1) {
          newWishesItems.push(String(idItem));
        }
        this.store.dispatch({
          type: UserActions.ADD_USER_WISHED_ITEMS,
          payload: newWishesItems
        });
        localForage.setItem('wishesItems', newWishesItems);
      },
      error => {
        console.log(error);
      }
    );
  }

  removeWishedItemToLocalForage(idItem: string) {
    fromPromise(localForage.getItem('wishesItems')).subscribe(
      res => {
        const newWishesItems = Object.keys(res)
          .map(index => {
            return res[index];
          })
          .filter(item => {
            if (item !== idItem) {
              return item;
            }
          });
        this.store.dispatch({
          type: UserActions.REMOVE_USER_WISHED_ITEMS,
          payload: newWishesItems
        });
        localForage.setItem('wishesItems', newWishesItems);
      },
      error => {
        console.log(error);
      }
    );
  }
}
